import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable, firstValueFrom } from 'rxjs';
import { map, switchMap, take, tap } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { LoginResponse } from '../../models/auth.model';
import { UserData } from '../../models/user.model';

@Injectable({
    providedIn: 'root'
})
export class AuthService {
    private http = inject(HttpClient);
    private router = inject(Router);
    private activatedRoute = inject(ActivatedRoute);

    private apiUrl = environment.apiUrl;

    login(email: string, password: string, two_factor_code: string | undefined): Observable<LoginResponse | { two_factor_required: boolean }> {
        const body = two_factor_code ? { email, password, two_factor_code } : { email, password };
        return this.http.post<LoginResponse | { two_factor_required: boolean }>(`${this.apiUrl}/auth/login`, body)
            .pipe(
                map((response: LoginResponse | { two_factor_required: boolean }) => {
                    if ('two_factor_required' in response && typeof response.two_factor_required === 'boolean') {
                        return response;
                    } else if (response && 'success' in response && response.success) {
                        return response;
                    }
                    throw new Error('Invalid response structure');
                })
            );
    }


    forgotPassword(email: string): Observable<string> {
        const body = { email };
        return this.http.post<void>(`${this.apiUrl}/auth/request-password-reset`, body).pipe(
            map(() => 'The password reset email was sent out'))
    }


    logout(): Promise<void> {
        const logoutObservable = this.http.post<void>(`${this.apiUrl}/auth/logout`, null).pipe(
            switchMap(() => this.activatedRoute.queryParams.pipe(take(1))),
            tap((params: Record<string, string>) => {
                if (!params || Object.keys(params).length === 0) {
                    this.router.navigate(['/login']);
                }
            }),
            map(() => void 0)
        );
        return firstValueFrom(logoutObservable);
    }

    loginInfo(): Observable<UserData> {
        return this.http.get<UserData>(`${this.apiUrl}/auth/info`);
    }
}
